import { useMemo } from 'react';
import { useUiStore } from '../../store/ui-store.js';
import { useConfigStore } from '../../store/config-store.js';
import { Info } from 'lucide-react';

export function PropertiesPanel(): JSX.Element {
  const selection = useUiStore((s) => s.selection);
  const draft = useConfigStore((s) => s.draft);

  const content = useMemo(() => {
    if (!selection.id || !draft) return null;
    if (selection.kind === 'panel') {
      const panel = draft.panels.find((p) => p.id === selection.id);
      if (!panel) return null;
      return (
        <div className="space-y-3">
          <Row k="ID" v={panel.id} mono />
          <Row k="Name" v={panel.name} />
          <Row k="Slots" v={String(panel.layout.length)} />
          <Row
            k="Belegt"
            v={String(panel.layout.filter((s) => s.buttonId).length)}
          />
          <Row k="Erstellt" v={panel.createdAt} />
        </div>
      );
    }
    if (selection.kind === 'partyline') {
      const pl = draft.partylines.find((p) => p.id === selection.id);
      if (!pl) return null;
      return (
        <div className="space-y-3">
          <Row k="ID" v={pl.id} mono />
          <Row k="Name" v={pl.name} />
          <Row k="Mitglieder" v={String(pl.members.length)} />
        </div>
      );
    }
    if (selection.kind === 'button') {
      const btn = draft.buttons.find((b) => b.id === selection.id);
      if (!btn) return null;
      return (
        <div className="space-y-3">
          <Row k="ID" v={btn.id} mono />
          <Row k="Typ" v={btn.type} />
          <Row k="Source" v={btn.sourcePanelId} mono />
          <Row k="Volume" v={`${btn.volume}%`} />
        </div>
      );
    }
    return null;
  }, [selection, draft]);

  return (
    <aside className="w-[300px] shrink-0 border-l border-border bg-surface flex flex-col">
      <header className="h-14 px-5 flex items-center border-b border-border">
        <h2 className="text-sm font-semibold text-text">Eigenschaften</h2>
      </header>
      <div className="flex-1 overflow-auto p-5">
        {content ?? (
          <div className="flex flex-col items-center justify-center text-center text-text-mute h-full gap-2">
            <Info size={18} />
            <p className="text-xs">Wähle ein Element zum Bearbeiten.</p>
          </div>
        )}
      </div>
    </aside>
  );
}

function Row({ k, v, mono }: { k: string; v: string; mono?: boolean }): JSX.Element {
  return (
    <div className="flex flex-col gap-0.5">
      <span className="label-sm">{k}</span>
      <span
        className={[
          'text-sm text-text break-all',
          mono ? 'font-mono text-xs text-text-dim' : '',
        ].join(' ')}
      >
        {v}
      </span>
    </div>
  );
}
